import React, { Component } from "react";
import { connect } from "react-redux";

import TextField from "@material-ui/core/TextField";
import { saveCarInfo } from "../../../store/actions/customers";
import Style from "react-style-tag/lib/Style";

class PickupExtraInfo extends Component {
  render() {
    const { language, customTexts, is_required } = this.props;
    const inputLabelStyle = {
      transformOrigin: language == "english" ? "top left" : "top right",
      right: language == "arabic" ? 0 : "unset",
      left: language == "english" ? 0 : "unset",
    };
    return (
      <div style={{ marginTop: this.props.fromCart ? 30 : 35 }}>
        <Style>
          {`.MuiInput-underline:before {
                  border-bottom: 1px solid #0000001f !important;
              }`}
        </Style>
        <p
          className="box-title"
          style={{ textAlign: language === "arabic" ? "right" : "left" }}
        >
          {is_required?.["make_is_required"] ||
          is_required?.["color_is_required"] ||
          is_required?.["plate_is_required"]
            ? language == "arabic"
              ? "تفاصيل السيارة"
              : "Car details"
            : language == "arabic"
            ? "تفاصيل السيارة (اختياري)"
            : "Car details (optional)"}
        </p>
        <div
          style={{
            height: 235,
            direction: language == "english" ? "ltr" : "rtl",
            backgroundColor: "white",
            padding: "5px 20px 0px",
          }}
          className="w-100 bordered"
        >
          <div style={{ direction: language == "english" ? "ltr" : "rtl" }}>
            <div className="mt-2" style={{ marginBottom: 20 }}>
              <TextField
                id="makeTextField"
                label={
                  <span style={{ fontSize: "1rem" }}>
                    {language == "english" ? "Make" : "النوع"}
                  </span>
                }
                required={is_required?.["make_is_required"] ? true : false}
                color="primary"
                key={"makeKey"}
                name="make"
                fullWidth
                defaultValue={
                  this.props.address ? this.props.address.make || "" : ""
                }
                onBlur={(e) => this.props.saveCarInfo("make", e.target.value)}
                InputLabelProps={{
                  style: inputLabelStyle,
                  dir: language == "english" ? "ltr" : "rtl",
                }}
                InputProps={{
                  dir: language == "english" ? "ltr" : "rtl",
                }}
              />
            </div>
            <div className="mt-2" style={{ marginBottom: 20 }}>
              <TextField
                id="colorTextField"
                label={
                  <span style={{ fontSize: "1rem" }}>
                    {language == "english" ? "Color" : "اللون"}
                  </span>
                }
                required={is_required?.["color_is_required"] ? true : false}
                color="primary"
                key={"colorKey"}
                name="color"
                fullWidth
                defaultValue={
                  this.props.address ? this.props.address.color || "" : ""
                }
                onBlur={(e) => this.props.saveCarInfo("color", e.target.value)}
                InputLabelProps={{
                  style: inputLabelStyle,
                  dir: language == "english" ? "ltr" : "rtl",
                }}
                InputProps={{
                  dir: language == "english" ? "ltr" : "rtl",
                }}
              />
            </div>
          </div>
          <div className="mt-2">
            <TextField
              id="plateNumID"
              label={
                <span style={{ fontSize: "1rem" }}>
                  {language == "english" ? "Plate number" : "رقم اللوحة"}
                </span>
              }
              color="primary"
              key={"additionalKey"}
              name="additional"
              required={is_required?.["plate_is_required"] ? true : false}
              fullWidth
              defaultValue={
                this.props.address ? this.props.address.plateNumber || "" : ""
              }
              onBlur={(e) =>
                this.props.saveCarInfo("plateNumber", e.target.value)
              }
              InputLabelProps={{
                style: inputLabelStyle,
                dir: language == "english" ? "ltr" : "rtl",
              }}
              InputProps={{
                dir: language == "english" ? "ltr" : "rtl",
              }}
            />
          </div>

          {window.location.hostname === "eff.e-butler.com" && (
            <div className="mt-2 mb-3">
              <TextField
                id="ebutlerRow"
                label={
                  language == "english"
                    ? "Where are you parked?"
                    : "مكان وقوف السيارة"
                }
                color="primary"
                key={"ebutlerRow"}
                name="ebutlerRow"
                required={is_required ? true : false}
                fullWidth
                defaultValue={
                  this.props.address ? this.props.address.ebutlerRow || "" : ""
                }
                placeholder={
                  language == "english"
                    ? "Row and parking spot"
                    : "صف ومكان وقوف السيارات"
                }
                onBlur={(e) =>
                  this.props.saveCarInfo("ebutlerRow", e.target.value)
                }
                InputLabelProps={{
                  style: inputLabelStyle,
                  dir: language == "english" ? "ltr" : "rtl",
                }}
                InputProps={{
                  dir: language == "english" ? "ltr" : "rtl",
                }}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    address: state.customers.address,
    customTexts: state.store.store.settings.custom_texts,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    saveCarInfo: (type, value) => dispatch(saveCarInfo(type, value)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PickupExtraInfo);
